import {
    Component,
    Input,
    Output,
    EventEmitter,
    HostListener
} from '@angular/core';

export type ToggleTextFunction = (flipped: boolean) => string;

@Component({
    selector: 'card-toggle',
    template: `
        @if (!getToggleText) {
            <a class="card-toggle_icon">
                <i class="fa fa-cog" aria-hidden="true"></i>
            </a>
        } @else {
            <span>{{ getToggleText(toggled) }}</span>
        }
    `,
    standalone: false
})
export class CardToggleComponent {
    @Input()
    getToggleText: ToggleTextFunction;
    @Input()
    toggled: boolean;

    @Output()
    readonly toggleClick = new EventEmitter();

    @HostListener('click')
    onClick(): void {
        this.toggleClick.emit();
    }
}
